export default __webpack_public_path__ + "static/media/MBP2.cbf276f2.mp4";